import { useEffect, useRef } from 'react';

/**
 * Allows for conditionally locking scrolling.
 * When true is passed in, the user cannot scroll.
 */
const useScrollLock = (lock = true) => {
  // SSR-safe: Use null as initial value, get actual value in useEffect
  const original = useRef<string | null>(null);

  useEffect(() => {
    // Initialize the ref with the current overflow value on first render
    if (original.current === null && typeof document !== 'undefined') {
      original.current = getComputedStyle(document.body).overflow;
    }

    if (lock) {
      if (original.current === null) {
        original.current = getComputedStyle(document.body).overflow;
      }
      document.body.style.overflow = 'hidden';
    } else {
      if (original.current !== null) {
        document.body.style.overflow = original.current;
      }
    }

    return () => {
      if (original.current !== null) {
        document.body.style.overflow = original.current;
      }
    };
  }, [lock]);
};

export default useScrollLock;
